module.exports = require("./ff.d.ts");